import React, { useEffect, useState } from 'react';
import { Modal as MantineModal } from '@mantine/core';
import { MediaInfo } from '~/src/types/posts';
import { Carousel } from '@mantine/carousel';
import { EmblaCarouselType } from 'embla-carousel';

interface MediaViewerProps {
  media: MediaInfo[];
  initialIndex: number;
  opened: boolean;
  onClose: () => void;
}

export default function MediaViewer({ media, initialIndex, opened, onClose }: MediaViewerProps) {
  const [embla, setEmbla] = useState<EmblaCarouselType | null>(null);

  useEffect(() => {
    if (embla) {
      embla.scrollTo(initialIndex);
    }
  }, [embla]); // Rerun effect when targetIndex or embla changes

  if (!media || media.length === 0) {
    return null;
  }

  return (
    <MantineModal fullScreen opened={opened} onClose={onClose} padding={0} withCloseButton={true} centered>
      <Carousel
        getEmblaApi={setEmbla}
        withIndicators={media.length > 1}
        height={600}
        styles={{
          control: {
            backgroundColor: 'var(--global-gray-lighter-7)',
            border: 'none',
            color: 'black',
            borderRadius: '50%',
            width: '32px',
            height: '32px',
            '&:hover': {
              backgroundColor: 'var(--global-gray-lighter-8)',
            },
          },
          indicator: {
            backgroundColor: 'var(--global-main-darker-3)',
            width: '8px',
            height: '8px',
          },
        }}
        controlSize={10}
        withControls={media.length > 1 && window.innerWidth > 768}
      >
        {media.map((mediaItem, index) => (
          <Carousel.Slide key={mediaItem.id.toString()}>
            <div
              style={{
                position: 'relative',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'var(--global-gray-lighter-7)',
              }}
            >
              <img
                src={mediaItem.main_url}
                alt={`Post image ${index + 1}`}
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                }}
                onError={(e) => {
                  e.currentTarget.src = mediaItem.main_url;
                }}
              />
            </div>
          </Carousel.Slide>
        ))}
      </Carousel>
    </MantineModal>
  );
}
